import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import { Box, Divider, GridItem, Grid } from "datastory-shared/ui"

import { Listing } from "./Listing"
import { TagGroup } from "./TagGroup"
import { Heading } from "./Heading"
import { Controls } from "./Controls"

export const ListingPage = ({ glossaryItems, categories, category }) => {
  const [viewType, setViewType] = useState("grid")
  const [selectedCategory, setSelectedCategory] = useState(
    category ? category : "all"
  )
  const [sortBy, setSortBy] = useState("desc")

  useEffect(() => {
    setSelectedCategory(category ? category : "all")
  }, [category])

  return (
    <Box mb="lg">
      <Heading />
      <TagGroup categories={categories} selectedCategory={selectedCategory} />
      <Controls
        setViewType={setViewType}
        viewType={viewType}
        setSortBy={setSortBy}
        sortBy={sortBy}
      />
      <Listing
        glossaryItems={glossaryItems}
        selectedCategory={selectedCategory}
        sortBy={sortBy}
        viewType={viewType}
      />
      <Grid>
        <GridItem colSpan={[4, 6, null, 12]} pt="xl">
          <Divider />
        </GridItem>
      </Grid>
    </Box>
  )
}

ListingPage.propTypes = {
  glossaryItems: PropTypes.array,
  categories: PropTypes.array,
  category: PropTypes.string,
}
